import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const VOUCHER_BOX_API_URL = `${API_HOST}/api/voucherBox`;

function* searchVoucherBoxes() {
  yield takeEvery(actions.SEARCH_VOUCHER_BOXES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${VOUCHER_BOX_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_VOUCHER_BOXES_ENDED });
    }
  });
}

function* createVoucherBox() {
  yield takeEvery(actions.CREATE_VOUCHER_BOX, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], VOUCHER_BOX_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_VOUCHER_BOX_ENDED });
    }
  });
}

function* updateVoucherBox() {
  yield takeEvery(actions.UPDATE_VOUCHER_BOX, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], VOUCHER_BOX_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_VOUCHER_BOX_ENDED });
    }
  });
}

function* deleteVoucherBoxes() {
  yield takeEvery(actions.DELETE_VOUCHER_BOXES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], VOUCHER_BOX_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_VOUCHER_BOXES_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createVoucherBox),
    fork(searchVoucherBoxes),
    fork(updateVoucherBox),
    fork(deleteVoucherBoxes),
  ]);
}
